import type { LanguageChoice } from '../i18n/languages';

export const accessKeys = {
  all: ['access'] as const,
  me: () => [...accessKeys.all, 'me'] as const,
  siteAccess: (plantIds: readonly string[]) => [...accessKeys.all, 'site-access', plantIds.join(',')] as const,
  /** One sidebar per language: its labels are the server's, in the language asked for. */
  sidebar: (language: LanguageChoice) => [...accessKeys.all, 'sidebar', language] as const,
};

export const ACCESS_STALE = 5 * 60 * 1000;
export const SITE_ACCESS_STALE = 60 * 1000;
export const ACCESS_GC = 10 * 60 * 1000;
